function isUndefined(subject: any): subject is undefined {
  return subject === undefined;
}

export function filterUndefined<A>(arr: readonly A[] | undefined) {
  if (!arr) {
    return [];
  }
  return arr.filter(
    (item): item is Exclude<A, undefined> => !isUndefined(item)
  );
}
